import { GetProductsFromFavoriteCategoriesViewDto } from '@src/api';

import { LoyaltyProgramCategoryList } from '../models';
import { convertToProductList } from '../services/utils/convertToProductList';

export const apiCategoriesToCategoriesUI = (
  categories?: GetProductsFromFavoriteCategoriesViewDto[] | null,
): LoyaltyProgramCategoryList[] => {
  return (
    categories?.map(category => {
      return <LoyaltyProgramCategoryList>{
        ...category,
        products:
          category.products?.map(product => {
            return convertToProductList(product);
          }) ?? [],
      };
    }) ?? []
  );
};
